const UserActions = {
    // the base ajax triple
    START_LOAD: "user/start-load",
    LOADED: "user/loaded",
    LOAD_ERROR: "user/load-error",
    // license prefs
    UPDATE_LICENSE_PREFERENCE: "user/update-license-preference",
    LICENSE_PREFERENCE_UPDATED: "user/license-preference-updated",
    LICENSE_PREFERENCE_UPDATE_ERROR: "user/license-preference-update-error",
    // user-org prefs
    UPDATE_ORG_USER_PREFERENCE: "user/update-org-user-preference",
    ORG_USER_PREFERENCE_UPDATED: "user/org-user-preference-updated",
    ORG_USER_PREFERENCE_UPDATE_ERROR: "user/org-user-preference-update-error",
};

export default UserActions;



// WEBPACK FOOTER //
// ./app/data/UserActions.js